import { Search, lib } from '@giscube/geoportal'
import GoogleSearchResultPopup from '../components/GoogleSearchResultPopup.vue'

export default class CustomSearch extends Search {
  parseGeocoderItem (result) {
    let item = {
      'group': null,
      'origin': 'google',
      'address': result.formatted_address,
      'geojson': {
        'type': 'Feature',
        'geometry': {
          'type': 'Point',
          'coordinates': [result.geometry.location.lng(), result.geometry.location.lat()]
        },
        'properties': {
          'title': result.formatted_address
        }
      },
      'title': result.formatted_address,
      'children': [],
      'latlng': {
        'type': 'Point',
        'coordinates': [result.geometry.location.lng(), result.geometry.location.lat()]
      }
    }
    return item
  }

  parseGeocoderError (status) {
    if (status === window.google.maps.GeocoderStatus.ZERO_RESULTS) {
      console.log('Google: zero results')
    } else if (status === window.google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
      console.log('Google: over query limit')
    } else if (status === window.google.maps.GeocoderStatus.REQUEST_DENIED) {
      console.log('Google: request denied')
    } else if (status === window.google.maps.GeocoderStatus.INVALID_REQUEST) {
      console.log('Google: invalid request denied')
    } else {
      console.log('Google: undefined error')
    }
  }

  searchGoogle (q) {
    return new Promise(async (resolve, reject) => {
      await lib.initGmaps(this.$config.google.apiKey)

      if (!(window.google && window.google.maps)) {
        console.log('Google maps api not ready yet, try later')
        return
      }

      // Reus boundary to avoid searches outside
      let searchBounds = { 'east': 1.138802, 'north': 41.177879, 'south': 41.123203, 'west': 1.048164 }

      // Geocode query
      let geocoder = new window.google.maps.Geocoder()
      let items = []
      let params = { 'address': q, 'bounds': searchBounds }
      geocoder.geocode(params, (result, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          items = result.map(item => this.parseGeocoderItem(item))
        } else {
          this.parseGeocoderError(status)
        }
        resolve(items)
      })
    })
  }

  showResultLayer (result) {
    if (!result.layer) {
      result.layer = lib.geomUtils.createGeoJSONLayer({ result, popupComponent: GoogleSearchResultPopup })
    }
    this.$context.rootState.search.resultsLayer.addLayer(result.layer)
  }

  setSearchGoogle (q) {
    this.promises.push(new Promise((resolve, reject) => {
      this.searchGoogle(q)
        .then(results => {
          // afegir marcadors al mapa
          results.forEach(item => this.showResultLayer(item))
          // retornar resultats que s'afegiran al panell de cerca
          resolve(results)
        })
    }))
  }

  setAllSearches (q) {
    if (this.$context.rootState.infraplan.googleSearch) {
      this.setSearchGoogle(q)
    } else {
      super.setAllSearches(q)
    }
  }
}
